module.exports = __webpack_public_path__ + "static/media/Load-75.1918ead4.svg";